/**
 * AI Recruit - Stage Acknowledgement Public (Candidate) API Service
 * Plain axios client, deliberately NOT the `apiV2` instance — this flow is
 * unauthenticated (the token in the URL is the credential) and must never
 * go through the auth-token/401-refresh/logout interceptors `apiV2` has.
 * Mirrors liveInterviewPublicApi.ts / proctoredInterviewPublicApi.ts's
 * shape/conventions exactly.
 */

import axios from 'axios'
import { API_V2_URL } from './api'

const publicApi = axios.create({
  baseURL: `${API_V2_URL}/public/stage-acknowledgement`,
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' },
})

export interface PublicStageAcknowledgement {
  candidate_name: string
  job_title: string
  round_code: string
  label: string
  decision: 'Selected' | 'Rejected'
  // Built defensively: the backend may expose the attached PDF as a direct
  // url, or only via the dedicated .../pdf download endpoint below — either
  // is handled (see AcknowledgementPage.tsx).
  pdf_url?: string | null
  already_acknowledged: boolean
  feedback_text?: string | null
  acknowledged_at?: string | null
}

export const getPublicStageAcknowledgement = (token: string) =>
  publicApi.get<PublicStageAcknowledgement>(`/${token}`).then((r) => r.data)

export interface SubmitStageAcknowledgementPayload {
  feedback_text: string
  acknowledged: true
}

export const submitPublicStageAcknowledgement = (token: string, payload: SubmitStageAcknowledgementPayload) =>
  publicApi.post(`/${token}/submit`, payload).then((r) => r.data)

// Not fetched via axios — used directly as an <a href>/window.open target
// (same treatment as a browser-native PDF download link).
export const getPublicStageAcknowledgementPdfUrl = (token: string) =>
  `${API_V2_URL}/public/stage-acknowledgement/${token}/pdf`
